import gql from 'graphql-tag';

export const LoomEntryPointsQuery = gql`
	query LoomEntryPointsQuery($cloudId: ID!) {
		confluence_loomEntryPoints(cloudId: $cloudId) {
			isLoomEntryPointsEnabled
		}
	}
`;
